<script lang="ts">
  import { reportRequest } from '../lib/reportRequest';
  import { importDownloadURL } from '../lib/imports';

  async function open() {
    const r = $reportRequest; if (!r) return;
    try { const url = await importDownloadURL(r.path); window.open(url, '_blank'); } catch { /* ignore */ }
    reportRequest.set(null);
  }
</script>

{#if $reportRequest}
  <div class="rb" role="status">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9zM14 3v6h6" /></svg>
    <span class="rbtext">Report ready · <b>{$reportRequest.name}</b></span>
    <button class="rbopen" onclick={open}>Open</button>
    <button class="rbx" onclick={() => reportRequest.set(null)} aria-label="Dismiss">✕</button>
  </div>
{/if}

<style>
  .rb { position: fixed; left: 50%; bottom: calc(var(--safe-bottom, 0px) + var(--space-10)); transform: translateX(-50%); z-index: var(--z-toast, 60); display: inline-flex; align-items: center; gap: var(--space-3); padding: var(--space-2) var(--space-3); border-radius: var(--radius-pill); background: color-mix(in srgb, var(--surface) 92%, transparent); border: 1px solid color-mix(in srgb, var(--accent) 40%, transparent); box-shadow: 0 12px 40px -12px color-mix(in srgb, var(--bg) 90%, black); backdrop-filter: blur(10px); }
  .rb svg { width: 16px; height: 16px; color: var(--accent); flex: 0 0 auto; }
  .rbtext { font-size: var(--fs-sm); color: var(--text-2); }
  .rbtext b { color: var(--text); }
  .rbopen { padding: var(--space-1) var(--space-4); border-radius: var(--radius-pill); background: var(--accent-grad); color: var(--on-accent); font-weight: 700; font-size: var(--fs-xs); }
  .rbx { display: grid; place-items: center; width: 24px; height: 24px; border-radius: var(--radius-pill); color: var(--text-3); }
  .rbx:hover { color: var(--text); background: var(--surface-2); }
</style>
